export default "__VITE_ASSET__DVZirMCC__"